import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonViewIcon } from '@icons';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { AnalyticsType } from '@interfaces/analytics';
import { useClientSpecificDashboardButtonDisabled } from '@hooks/clientSpecificUtils';
import {
  MapFeatureFlagSlug,
  useMapFeatureFlag,
} from '@hooks/mapFeatureFlags';
import { DashboardButtonEnum } from '@constants/dashboard';

enum PersonViewEnum {
  FIRST_PERSON = 'FIRST_PERSON',
  THIRD_PERSON = 'THIRD_PERSON',
}

const PersonViewToggleButton = () => {
  const { isFirstPersonView, setIsFirstPersonView, disabledPersonView } =
    useConference();

  const { t: translate } = useTranslation();

  const { sendMessageToUnreal } = useMytaverse();
  const { trackEventAnalytics } = useMytaverseEvent();
  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.VIEW_TOGGLE_BUTTON,
  );
  const isToggleViewEnabled = useMapFeatureFlag(MapFeatureFlagSlug.ToggleView);

  const handleSetPersonView = useCallback(() => {
    const newStateIsFirstPersonView = !isFirstPersonView.flag;

    trackEventAnalytics(AnalyticsType.NavbarButtonClick, {
      name: 'toggle-view',
    });

    sendMessageToUnreal({
      action: 'TOGGLE_VIEW',
      view: newStateIsFirstPersonView
        ? PersonViewEnum.FIRST_PERSON
        : PersonViewEnum.THIRD_PERSON,
    });
  }, [
    sendMessageToUnreal,
    setIsFirstPersonView,
    isFirstPersonView,
    trackEventAnalytics,
  ]);

  if (!isToggleViewEnabled) {
    return null;
  }

  return (
    <HomeBarButton
      label={translate('tooltips.toggleView')}
      icon={<PersonViewIcon />}
      isActive={isFirstPersonView.flag}
      disabled={disabledPersonView || isDisabledClientSpecific}
      handleClick={handleSetPersonView}
    />
  );
};

export default PersonViewToggleButton;
